import React, { Fragment } from "react";
import classes from "./Spinner.module.css";

const Spinner = () => {
  return (
    <Fragment>
      <div className={classes["lds-spinner"]}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <p>Loading...</p>
    </Fragment>
  );
};

export default Spinner;